import type { ReactNode } from "react";

import Header from "./Header";
import CTA from "./CTA";
import Footer from "./Footer"; // 👈 new import

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="relative min-h-screen flex flex-col">
      <Header />

      <main className="relative z-0">
        {children}
        <div className="mx-auto max-w-screen-xl">
          <CTA />
        </div>
      </main>

      <Footer /> {/* 👈 footer always at bottom */}
    </div>
  );
}
